import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Ldap } from './../../core/models/ldap';
import { ConfirmDialogComponent } from 'app/shared/components/confirm-dialog/confirm-dialog.component';
import * as _ from 'lodash';
import { BzgModalService} from 'bz-genome-angular';
import { DeleteConfirmationComponent } from 'app/shared/components/delete-confirmation/delete-confirmation.component';

@Component({
    selector: 'ldap-default-values',
    templateUrl: 'ldap-default-values.component.html',
    styleUrls: ['ldap-default-values.component.scss']
})
export class LdapDefaultValuesComponent implements OnInit {
    @Input() ldapConfiguration: Ldap;
    @Input() userProperties: any[] = [];
    @ViewChild('confirmDialogDefault', { static: false}) confirmDialog: ConfirmDialogComponent;

    public isloading = false;
    public defaults: Array<any> = [];
    public isOnlyChecked: boolean;

    constructor(private _modalService: BzgModalService) { }

    ngOnInit() {
        this.isloading = true;
        let i = 0;

        for (const defaultp in this.ldapConfiguration.defaults) {
            if (this.ldapConfiguration.defaults.hasOwnProperty(defaultp)) {
                let key: any = _.find(this.userProperties, (u) => u.value === defaultp);
                if(!key){
                    key = { value: '' };
                }

                const value = this.ldapConfiguration.defaults[defaultp];

                this.defaults.push({ key, value, position: i, state: false });
                i++;
            }
        }
        this.isloading = false;
    }

    public addDefaultValue() {
        const currentPosition = this.defaults.length;
        this.defaults.push({ key: { value: '' }, value: '', position: currentPosition, state: false });
    }

    public changeValueMapping(value: any, position: any) {
        const itemMapping = _.find(this.defaults, { position });
        itemMapping.key = value;
        this.setFinalDefaultValue();
    }

    public changeTextMapping(value: any, position: number) {
        const itemMapping = _.find(this.defaults, (d) => d.position === position);
        itemMapping.value = value;
        this.setFinalDefaultValue();
    }

    public deleteDefaultValue(value: any) {
        const modal = this._modalService.open(DeleteConfirmationComponent, {
          closeOnBackdropClick: false,
          closeOnRouterNavigation: true,
          data: { title: 'LDAP.DELETE_ROW', message: 'LDAP.DELETE_ROW_CONFIRM' } });
        modal.afterClosed().subscribe((result) => {
            if (result === 'delete') {
                const index = this.defaults.indexOf(value);
                this.defaults.splice(index, 1);
                this.setFinalDefaultValue();
            }
        });
    }

    private setFinalDefaultValue() {
        this.ldapConfiguration.defaults = {};

        _.forEach(this.defaults, (each) => {
            this.ldapConfiguration.defaults[each.key.value] = each.value;
        });
    }
}
